export default __webpack_public_path__ + "static/media/176.e2f0a549.png";